import { useEffect, useState } from 'react';
import {
  canFullscreen,
  enterFullscreen,
  exitFullscreen,
  isFullscreenActive,
} from '../services/fullscreen';

/** Следит за полноэкранным режимом ТВ-браузера. */
export function useTvFullscreen() {
  const [active, setActive] = useState(false);
  const available = canFullscreen();

  useEffect(() => {
    const sync = () => setActive(isFullscreenActive());
    document.addEventListener('fullscreenchange', sync);
    document.addEventListener('webkitfullscreenchange', sync);
    sync();
    return () => {
      document.removeEventListener('fullscreenchange', sync);
      document.removeEventListener('webkitfullscreenchange', sync);
    };
  }, []);

  const toggle = async () => {
    try {
      if (isFullscreenActive()) {
        await exitFullscreen();
      } else {
        await enterFullscreen();
      }
    } catch (error) {
      console.error('Не удалось переключить полный экран:', error);
    }
  };

  return { active, available, toggle };
}
